import { RecordLine, RecordProperties } from './../../layout/record-model';
import { CellValueChangedArgs } from 'src/app/layout/cell-value-changed-args';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from 'src/app/layout/layout.service';
import {
  FieldDataType,
  ModuleStructure,
  Section,
} from 'src/app/models/module-structure';
import { RecordModel, RecordCategory } from 'src/app/layout/record-model';
import * as g from 'src/app/globals';

export class Payments {
  static validateBeforeSubmit(recordModel: RecordModel): string {
    if (
      recordModel.ObjectKey === 'oIncomingPayments' ||
      recordModel.ObjectKey === 'oVendorPayments'
    ) {
      let category: RecordCategory;

      category = recordModel.Categories.find(
        (c) => c.Id === 'Payments_Invoices'
      );
      category.Lines = [];
      if (category.Dataset !== undefined) {
        category.Dataset.forEach((element) => {
          const lineIsSelected =
            element.ITMSelected === true || element.ITMSelected === 'true';
          let newSectionAdded = false;
          if (lineIsSelected) {
            const columnDocEntry = 'Payments_Invoices.DocEntry';
            const columnInvType = 'Payments_Invoices.InvoiceType';
            const columnDocLine = 'Payments_Invoices.DocLine';
            const columnSumApplied = 'Payments_Invoices.SumApplied';
            if (!newSectionAdded) {
              let recordCategory: RecordCategory = null;
              recordCategory = {
                Id: 'Payments_Invoices',
                Lines: [],
                DeletedLines: [],
              };
              let recordLine: RecordLine = null;
              recordLine = {
                Id: recordCategory.Lines.length,
                Properties: [],
              };
              let recordProperty: RecordProperties = {
                DataType: FieldDataType.String,
                Name: 'DocEntry',
                FieldName: 'DocEntry',
                ValueAsObject: element[columnDocEntry],
              };
              recordLine.Properties.push(recordProperty);

              recordProperty = {
                DataType: FieldDataType.String,
                Name: 'InvoiceType',
                FieldName: 'InvoiceType',
                ValueAsObject: element[columnInvType],
              };
              recordLine.Properties.push(recordProperty);

              recordProperty = {
                DataType: FieldDataType.String,
                Name: 'DocLine',
                FieldName: 'DocLine',
                ValueAsObject: element[columnDocLine],
              };
              recordLine.Properties.push(recordProperty);

              recordProperty = {
                DataType: FieldDataType.String,
                Name: 'SumApplied',
                FieldName: 'SumApplied',
                ValueAsObject: element[columnSumApplied],
              };
              recordLine.Properties.push(recordProperty);
              category.Lines.push(recordLine);

              // recordModel.Categories.push(recordCategory);
              newSectionAdded = true;
            }
          }
        });
      }
    }
    return '';
  }

  isDocument = true;
  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService
  ) {
    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      try {
        this.oPayments(args);
      } catch (e) {
        console.log(
          'An error occured while trying to execute oPayments',
          args,
          e
        );
      }
    });

    layoutService.objectLoadChanged.subscribe(
      (args: {
        recordModel: RecordModel;
        moduleStructure: ModuleStructure;
      }) => {
        try {
          this.ObjectLoad(args.recordModel, args.moduleStructure);
        } catch (e) {
          console.log('error during loading the object, the error is:', e);
        }
      }
    );

    layoutService.cellValueChanged.subscribe((args: CellValueChangedArgs) => {
      if (
        args.column.Name === 'ITMSelected' ||
        args.column.Name === 'Payments_Invoices.SumApplied'
      ) {
        this.changeCheckAmount(args.recordModel, args.column.Name, true);
      }
      if (args.column.Name === 'ITMSelected') {
        this.payment_InitializeNewPayment(
          args.recordModel,
          args.moduleStructure
        );

        this.initializePaymentMeans(args.recordModel, args.moduleStructure);
      }
    });

    this.layoutService.deleteRowEmitter.subscribe((args) => {
      //console.log(args);
      this.changeCheckAmount(
        args.recordModel,
        'Payments_Invoices.SumApplied',
        false
      );
    });
  }

  changeCheckAmount(
    recordModel: RecordModel,
    columnName: string,
    cellChange: boolean
  ) {
    //console.log('here');
    const paymentCheckSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments'
    );

    if(paymentCheckSection == null || paymentCheckSection === undefined){
      return;
    }

    const SumApplied = this.getSumInvoiceApplied(recordModel, columnName);

    if (g.setSumAppliedInCash && SumApplied !== 0 && cellChange) {
      paymentCheckSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'CashSum'
      ).ValueAsObject = SumApplied;
    }
    else if (g.setSumAppliedInCash && SumApplied === 0 && cellChange) {
      paymentCheckSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'CashSum'
      ).ValueAsObject = SumApplied;
    }

    const totals = this.getPaymentTotal(recordModel);

    paymentCheckSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocTotal'
    ).ValueAsObject = totals;

    paymentCheckSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'OpenBal'
    ).ValueAsObject = totals - SumApplied;

    paymentCheckSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'NoDocSum'
    ).ValueAsObject = totals - SumApplied;
  }

  getPaymentTotal(recordModel: RecordModel) {
    let totals = 0;

    totals = this.getSumCheckAmountl(recordModel);
    totals += this.getSumCCAmount(recordModel);

    const paymentCheckSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments'
    );

    totals += Number(
      paymentCheckSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'CashSum'
      ).ValueAsObject
    );
    totals += Number(
      paymentCheckSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'TransferSum'
      ).ValueAsObject
    );
    return totals;
  }

  getSumCheckAmountl(recordModel: RecordModel) {
    const paymentCheckSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments_Checks'
    );

    let Total = 0;

    paymentCheckSection.Lines.forEach((element) => {
      let CheckAmount = 0;
      const checkSumElement = element.Properties.find(
        (prop) => prop.Name === 'CheckSum'
      );
      if (
        checkSumElement === undefined ||
        checkSumElement.ValueAsObject === undefined ||
        checkSumElement.ValueAsObject === ''
      ) {
        CheckAmount = 0;
      } else {
        CheckAmount = Number(checkSumElement.ValueAsObject);
      }
      Total += CheckAmount;
    });

    return Total;
  }

  getSumCCAmount(recordModel: RecordModel) {
    const paymentCreditSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments_CreditCards'
    );

    let Total = 0;

    paymentCreditSection.Lines.forEach((element) => {
      let ccAmount = 0;
      const creditSumElement = element.Properties.find(
        (prop) => prop.Name === 'CreditSum'
      );
      if (
        creditSumElement === undefined ||
        creditSumElement.ValueAsObject === undefined ||
        creditSumElement.ValueAsObject === ''
      ) {
        ccAmount = 0;
      } else {
        ccAmount = Number(creditSumElement.ValueAsObject);
      }
      Total += ccAmount;
    });

    return Total;
  }

  getSumInvoiceApplied(recordModel: RecordModel, columnName: string) {
    let Total = 0;

    const paymentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments'
    );
    const PaymentCurrency = paymentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocCurrency'
    ).ValueAsObject;

    let category: RecordCategory;
    if (recordModel.ObjectKey === 'oIncomingPayments') {
      category = recordModel.Categories.find(
        (c) => c.Id === 'Payments_Invoices'
      );
    } else {
      category = recordModel.Categories.find(
        (c) => c.Id === 'Payments_Invoices'
      );
    }

    if (category.Dataset !== undefined) {
      category.Dataset.forEach((element) => {
        const lineIsSelected =
          element.ITMSelected === true || element.ITMSelected === 'true';

        if (lineIsSelected) {
          let Applied = 0;
          if (columnName === 'Payments_Invoices.SumApplied') {
            Applied = element[columnName];
          } else {
            const InvoiceCurrency = element.DocCur.trim();

            if (PaymentCurrency === g.companyConfiguration.LocalCurrency) {
              Applied = element.DocTotal - element.PaidToDate;
            } else {
              Applied = element.DocTotalFC - element.PaidFC;
            }

            element['Payments_Invoices.SumApplied'] = Applied;
          }
          Total += Applied;
        }
      });
    }

    return Total;
  }

  ObjectLoad(recordModel: RecordModel, moduleStructure: ModuleStructure) {
    if (recordModel.ObjectKey === 'oIncomingPayments') {
      const acountSection: Section = moduleStructure.module.Sections.find(
        (x) => x.XmlTagName === 'Payments_Accounts'
      );

      acountSection.AdditionalInformationParsed.Hidden = true;

      this.initializePaymentMeans(recordModel, moduleStructure);

      return;
    }
  }

  oPayments(args: FieldValueChangedArgs) {
    const currentObject = args.recordModel.ObjectKey;
    this.isDocument = true;
    if (
      currentObject === 'oIncomingPayments' ||
      currentObject === 'oVendorPayments' ||
      currentObject === 'oContacts'
    ) {
      this.isDocument = false;
    }
    if (args.sectionTagName === 'Payments') {
      if (
        args.recordProperty.Name === 'CashSum' ||
        args.recordProperty.Name === 'TransferSum'
      ) {
        this.changeCheckAmount(
          args.recordModel,
          'Payments_Invoices.SumApplied',
          false
        );

        this.payment_InitializeNewPayment(
          args.recordModel,
          args.moduleStructure
        );

        this.initializePaymentMeans(args.recordModel, args.moduleStructure);
      }
    }

    if (args.sectionTagName === 'Payments_CreditCards') {
      if (args.recordProperty.Name === 'CreditSum') {
        this.changeCheckAmount(
          args.recordModel,
          'Payments_Invoices.SumApplied',
          false
        );

        this.payment_InitializeNewPayment(
          args.recordModel,
          args.moduleStructure
        );

        this.initializePaymentMeans(args.recordModel, args.moduleStructure);
      }
    }

    if (args.sectionTagName === 'Payments_Checks') {
      if (args.recordProperty.Name === 'CheckSum') {
        this.changeCheckAmount(
          args.recordModel,
          'Payments_Invoices.SumApplied',
          false
        );

        this.payment_InitializeNewPayment(
          args.recordModel,
          args.moduleStructure
        );

        this.initializePaymentMeans(args.recordModel, args.moduleStructure);
      }
    }

    if (args.sectionTagName === 'Payments_Invoices') {
      if (args.recordProperty.Name === 'SumApplied') {
        this.payment_InitializeNewPayment(
          args.recordModel,
          args.moduleStructure
        );

        this.initializePaymentMeans(args.recordModel, args.moduleStructure);
      }
    }

    if (args.sectionTagName === 'Documents') {
      this.initializePaymentMeans(args.recordModel, args.moduleStructure);
    }

    if (currentObject === 'oDownPayments') {
      if (args.recordProperty.Name === 'TotalBeforeDiscount') {
        this.calculateDPMTotal(args.recordModel, args.moduleStructure);
      }
      if (args.recordProperty.Name === 'TotalDPM') {
        this.calculateDPMPercent(args.recordModel, args.moduleStructure);
      }
    }
  }

  calculateDPMTotal(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure
  ) {
    const documentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );

    const documentTotal = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalBeforeDiscount'
    ).ValueAsObject;

    const percentage = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DownPaymentPercentage'
    ).ValueAsObject;

    const totalPayment = (documentTotal * percentage) / 100;

    LayoutService.setValue(
      documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'TotalDPM'
      ),
      totalPayment,
      this.layoutService,
      recordModel,
      0,
      'Documents',
      moduleStructure
    );
  }

  calculateDPMPercent(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure
  ) {
    const documentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );

    const documentTotal = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalBeforeDiscount'
    ).ValueAsObject;

    const totalPaid = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalDPM'
    ).ValueAsObject;

    const percent = (totalPaid / documentTotal) * 100;

    LayoutService.setValue(
      documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'DownPaymentPercentage'
      ),
      percent,
      this.layoutService,
      recordModel,
      0,
      'Documents',
      moduleStructure
    );
  }

  payment_InitializeNewPayment(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure
  ) {
    const paymentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments'
    );

    const documentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );

    const cash = paymentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'CashSum'
    ).ValueAsObject;

    const transfer = paymentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'TransferSum'
    ).ValueAsObject;

    let totalCC = 0;

    const paymentCreditSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments_CreditCards'
    );

    paymentCreditSection.Lines.forEach((element) => {
      let ccAmount = 0;
      const creditSumElement = element.Properties.find(
        (prop) => prop.Name === 'CreditSum'
      );
      if (
        creditSumElement === undefined ||
        creditSumElement.ValueAsObject === undefined ||
        creditSumElement.ValueAsObject === ''
      ) {
        ccAmount = 0;
      } else {
        ccAmount = Number(creditSumElement.ValueAsObject);
      }
      totalCC = totalCC + ccAmount;
    });

    if (this.isDocument && documentsSection !== undefined) {
      LayoutService.setValue(
        documentsSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'ITM_TotalPaid'
        ),
        cash + transfer + totalCC,
        this.layoutService,
        recordModel,
        0,
        'Documents',
        moduleStructure
      );
    }
  }

  initializePaymentMeans(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure
  ) {
    let total = 0;
    let alreadyPaid = 0;
    let newPayments = 0;
    let remaining = 0;

    const documentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );

    if (this.isDocument && documentsSection !== undefined) {
      total = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'DocTotal'
      )?.ValueAsObject;

      if (
        documentsSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'ITM_Real_TotalPaid'
        ) === undefined
      ) {
        return;
      }

      alreadyPaid = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'ITM_Real_TotalPaid'
      ).ValueAsObject;

      newPayments = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'ITM_TotalPaid'
      ).ValueAsObject;

      remaining = total - (alreadyPaid + newPayments);

      if (this.isDocument && documentsSection !== undefined) {
        LayoutService.setValue(
          documentsSection.Lines[0].Properties.find(
            (prop) => prop.Name === 'ITM_BalanceDue'
          ),
          remaining,
          this.layoutService,
          recordModel,
          0,
          'Documents',
          moduleStructure
        );
      }
    } else {
      const currentObject = recordModel.ObjectKey;
      if (
        currentObject === 'oIncomingPayments' ||
        currentObject === 'oVendorPayments'
      ) {
        total = this.getSumInvoiceDocTotal(
          recordModel,
          moduleStructure,
          currentObject
        );
        alreadyPaid = this.getSumInvoicePaidToDate(
          recordModel,
          moduleStructure,
          currentObject
        );
        newPayments = this.getPaymentTotal(recordModel);
        remaining = total - (alreadyPaid + newPayments);

        if (this.isDocument && documentsSection !== undefined) {
          LayoutService.setValue(
            documentsSection.Lines[0].Properties.find(
              (prop) => prop.Name === 'ITM_BalanceDue'
            ),
            remaining,
            this.layoutService,
            recordModel,
            0,
            'Documents',
            moduleStructure
          );
        }
      }
      if (currentObject === 'oContacts') {
        /*total = GetSumExpensesDocTotal(form);
        alreadyPaid = GetSumExpensesPaidToDate(form);
        newPayments = GetPaymentTotal(form);
        remaining =
          itmToNumber(total) -
          (itmToNumber(alreadyPaid) + itmToNumber(newPayments));
        form
          .find('[name="Documents.ITM_BalanceDue"]')
          .val(remaining.itmFAmount());*/
      }
    }

    /*$('.document-total').text(itmFAmount(total));
    $('.already-paid').text(itmFAmount(alreadyPaid));
    $('.new-paid').text(itmFAmount(newPayments));
    $('.open-balance').text(itmFAmount(remaining));*/
  }

  getSumInvoicePaidToDate(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure,
    currentObject: string
  ) {
    let Total = 0;

    let category: RecordCategory;
    if (currentObject === 'oIncomingPayments') {
      category = recordModel.Categories.find(
        (c) => c.Id === 'Payments_Invoices'
      );
    } else {
      category = recordModel.Categories.find(
        (c) => c.Id === 'Payments_Invoices'
      );
    }

    const paymentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments'
    );

    const PaymentCurrency = paymentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocCurrency'
    ).ValueAsObject;

    const PaymentRate = paymentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocRate'
    ).ValueAsObject;

    if (category.Dataset !== undefined) {
      category.Dataset.forEach((element) => {
        const lineIsSelected =
          element.ITMSelected === true || element.ITMSelected === 'true';

        if (lineIsSelected) {
          let PaidTotal = 0;
          const InvoiceCurrency = element.DocCur.trim();

          if (PaymentCurrency === g.companyConfiguration.LocalCurrency) {
            PaidTotal = element.PaidToDate;
          } else if (PaymentCurrency === InvoiceCurrency) {
            PaidTotal = element.PaidFC;
          } else {
            PaidTotal = element.PaidToDate;
            PaidTotal = PaidTotal / PaymentRate;
          }

          Total += PaidTotal;
        }
      });
    }
    return Total;
  }

  getSumInvoiceDocTotal(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure,
    currentObject: string
  ) {
    let category: RecordCategory;
    if (currentObject === 'oIncomingPayments') {
      category = recordModel.Categories.find(
        (c) => c.Id === 'Payments_Invoices'
      );
    } else {
      category = recordModel.Categories.find(
        (c) => c.Id === 'Payments_Invoices'
      );
    }

    const paymentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Payments'
    );

    let Total = 0;
    const PaymentCurrency = paymentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocCurrency'
    ).ValueAsObject;

    const PaymentRate = paymentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocRate'
    ).ValueAsObject;

    const PaymentDocDate = paymentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDate'
    ).ValueAsObject;

    if (category.Dataset !== undefined) {
      category.Dataset.forEach((element) => {
        const lineIsSelected =
          element.ITMSelected === true || element.ITMSelected === 'true';

        if (lineIsSelected) {
          let DocTotal = 0;
          const InvoiceCurrency = element.DocCur.trim();

          if (PaymentCurrency === g.companyConfiguration.LocalCurrency) {
            DocTotal = element.DocTotal;
          } else if (PaymentCurrency === InvoiceCurrency) {
            DocTotal = element.DocTotalFC;
          } else {
            DocTotal = element.DocTotal;
            DocTotal = DocTotal / PaymentRate;
          }

          Total += DocTotal;
        }
      });
    }
    return Total;
  }
}
